import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import styles from './Dropzone.module.scss';
import UploadIcon from '../Icons/Upload.svg';
import UploadIconHighlighted from '../Icons/Upload-Highlighted.svg';

function Dropzone(props) {
    const { multifile, onDrop } = props;
    const onDropFunc = useCallback(
        (files) => onDrop(multifile ? files : files[0]),
        [onDrop, multifile]
    );
    const {
        getRootProps, getInputProps, isDragActive, open
    } = useDropzone({ onDrop: onDropFunc });

    const rootProps = getRootProps({ onClick: (event) => event.stopPropagation() });

    return (
        <div { ...rootProps } className={ styles.dropzoneContainer }>
            <div className={ styles.dropzoneContainerInner }>
                <div className={ styles.dropzone }>
                    <input { ...getInputProps() } />
                    <div className={ styles.dropzoneIconContainer }>
                        <div className={ styles.dropzoneIcon }>
                            <img alt="Upload file" src={ isDragActive ? UploadIconHighlighted : UploadIcon } />
                        </div>
                    </div>
                    <div className={ styles.label }>
                        { isDragActive ? 'Drop file here' : 'Drag & Drop files here' }
                    </div>
                    <div className={ styles.label }>or</div>

                    <div className={ styles.label }>
                        <button className={ styles.browseButton } type="button" onClick={ open }>
                            Browse files
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

Dropzone.propTypes = {
    onDrop: PropTypes.func.isRequired,
    multifile: PropTypes.bool
};

Dropzone.defaultProps = {
    multifile: false
};

export default Dropzone;
